import React from "react";
import { Link } from "react-router-dom";
import RecipeForm from "../../components/recipe-form";

export default function({ history }) {
  let newRecipe = { name: "" };

  function handleSave(recipe) {
    history.push(`/recipes/${recipe.id}`);
  }

  return (
    <div>
      <div className="flex items-center">
        <div className="w-1/3">
          <Link to="/" className="py-2 font-medium text-blue-500">
            Cancel
          </Link>
        </div>
        <div className="w-1/3">
          <h1 className="text-center text-xl font-bold leading-none">
            New recipe
          </h1>
        </div>
      </div>

      <div className="mt-8">
        <RecipeForm recipe={newRecipe} didSave={handleSave} />
      </div>
    </div>
  );
}
